import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
//import _adviserPortalHome from './_adviserPortalHome';
import TotalMembers from './TotalMembers';
import CommissionPayment from './CommissionPayment';
import TotalFum from './TotalFum';
import TotalFumLeft from './TotalFumLeft';
import TotalMembersComponentLeft from './TotalMembersComponentLeft';
import CommissionPaymentComponentLeft from './CommissionPaymentComponentLeft';
import '../css/AdviserData.css';
import { Col, Container, Row } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';

class AdviserData extends Component {
    render() {
        //const { t } = this.props;
        return (
            // <div>
            //     <Container fluid id="adviser-data-mobile">
            //         <Row>
            //             <Col className="adviser-data" rowSpan="2" style={{ display: "block" }}><TotalFum {...this.props}></TotalFum></Col>
            //             <Col className="adviser-data" rowSpan="2" style={{ display: "block" }}><TotalMembers {...this.props}></TotalMembers></Col>
            //             <Col className="adviser-data" rowSpan="2" style={{ display: "block" }}><CommissionPayment {...this.props}></CommissionPayment></Col>                
            //         </Row>
            //     </Container>
            //     <Container fluid id="adviser-data">
            //         {
            //             String(this.props.pathname).includes("login") && <TotalFumLeft {...this.props}></TotalFumLeft>
            //         }
            //         {
            //             String(this.props.pathname).includes("totalMembers") && <TotalMembersComponentLeft {...this.props}></TotalMembersComponentLeft>
            //         }
            //         {
            //             String(this.props.pathname).includes("commissionPayment") && <CommissionPaymentComponentLeft {...this.props}></CommissionPaymentComponentLeft>
            //         }
            //     </Container>
            // </div>
           

            <div id="adviserData">
                <table className="adviserData" id="adviserDataMobile">
                    <tbody>
                        <tr>
                            <td rowSpan="2" style={{ display: "block" }}><TotalFum {...this.props}></TotalFum></td>
                            <td rowSpan="2" style={{ display: "block" }}><TotalMembers {...this.props}></TotalMembers></td>
                            <td rowSpan="2" style={{ display: "block" }}><CommissionPayment {...this.props}></CommissionPayment></td>

                        </tr>
                    </tbody>
                </table>

                <table className="adviserData" id="adviserData" >
                    {
                        String(this.props.pathname).includes("login") && <TotalFumLeft {...this.props}></TotalFumLeft>
                    }
                    {
                        String(this.props.pathname).includes("totalMembers") && <TotalMembersComponentLeft {...this.props}></TotalMembersComponentLeft>
                    }
                    {
                        String(this.props.pathname).includes("commissionPayment") && <CommissionPaymentComponentLeft {...this.props}></CommissionPaymentComponentLeft>
                    }
                </table>
            </div>


            // <table class="adviserData">
            // <tbody>
            // <tr>
            // <td>
            //     <div className="adviserDataTotal"><CurrencyFormat  value={Number(totalFumDetails.totalFum).toFixed(2)} 
            //                 displayType={'text'} 
            //                 thousandSeparator={true} 
            //                 prefix={'$'}/></div>
            //     <div><Link className="adviserLoginLink link" to="/adv/totalMembers">{t('Total Superlife Fum')} </Link></div>
            // </td>
            // <td rowSpan="2" colSpan="2" style={{verticalAlign: "top"}}>
            // <MembersGraph advisers = {this.props.advisers} total= {this.props.advisersTotal}/>            
            // </td>
            // <td rowSpan="2" style={{verticalAlign: "top"}}><FumGraph advisers = {this.props.advisers} total= {this.props.advisersTotal}/></td>
            // </tr>
            // <tr>
            // <td>
            //     <div className="adviserDataSplit"><CurrencyFormat  value={Number(totalFumDetails.kiwiSaver).toFixed(2)} 
            //                 displayType={'text'} 
            //                 thousandSeparator={true} 
            //                 prefix={'$'}/></div>
            //     <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLKS">{t('Superlife KiwiSaver FUM')}</Link></div>
            // </td>

            // </tr>
            // <tr>
            // <td>
            //     <div className="adviserDataSplit"><CurrencyFormat  value={Number(totalFumDetails.invest).toFixed(2)} 
            //                 displayType={'text'} 
            //                 thousandSeparator={true} 
            //                 prefix={'$'}/></div>
            //     <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLI">{t('Superlife Invest FUM')}</Link></div>
            // </td>
            // <td rowSpan="2" style={{verticalAlign: "top"}}><ContributorsGraph advisers = {this.props.advisers} total= {this.props.advisersTotal}/></td>
            // <td rowSpan="2"><CommissionPayment {...this.props}></CommissionPayment></td>
            // <td rowSpan="2"><TotalMembers {...this.props}></TotalMembers></td>
            // </tr>
            // <tr>
            // <td>
            //     <div className="adviserDataSplit"><CurrencyFormat  value={Number(totalFumDetails.ukPension).toFixed(2)}
            //                 displayType={'text'} 
            //                 thousandSeparator={true} 
            //                 prefix={'$'}/></div>
            //     <div><Link className="adviserLoginDataLink link" to="/adv/totalMembers/SLUK">{t('Superlife UK FUM')}</Link></div>
            // </td>

            // </tr>
            // </tbody>
            // </table> 

        )
    }
}
export default withTranslation()(AdviserData);